
export default {
  // 状态码转换
  statusFilter: (code, defaultText = '未知') => {
    const statusMap = {
      A: '退款失败',
      P: '退款失败',
      F: '退款失败',
      S: '退款成功'
    };
    // 若 code 不存在于映射表，返回默认文本
    return statusMap[code] || defaultText;
  },

  // 支付方式
  paymentFilter: (code, defaultText = '未知') => {
    const paymentMap = { 'wx': '微信', 'zfb': '支付宝', 'twx': '腾讯微信', 'dyzfb': 'Alipay支付宝', 'ybwx': '微信 支付', 'ybzfb': '支付宝 支付', 'wechat': '小程序' };
    return paymentMap[code] || defaultText;
  }
};



// WEBPACK FOOTER //
// ./src/js/filter.js